// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1go3W","content":"styles_content__3o-F7","checkbox":"styles_checkbox__Ona56","checkboxLabel":"styles_checkboxLabel__24_Rr"};